const {
  NODE_ENV,
  APP_ENV,
  APP_VERSION,
  SENTRY_PUBLIC_KEY,
  ASSET_BASE_URL,
  FILESTACK_PUBLIC_KEY
} = process.env

const GOOGLE_MAPS_API_KEY = 'AIzaSyCr_eG5MH279owFCp3QHbBd949g45PqjOU'

export {
  APP_ENV,
  APP_VERSION,
  NODE_ENV,
  SENTRY_PUBLIC_KEY,
  ASSET_BASE_URL,
  FILESTACK_PUBLIC_KEY,
  GOOGLE_MAPS_API_KEY
}
